import { render, staticRenderFns } from "./block-info.vue?vue&type=template&id=61bf02a6"
import script from "./block-info.vue?vue&type=script&lang=js"
export * from "./block-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports